<template>

  <div class="gantt-container">
    <el-icon :size="16" color = "#606266" class="gantt-toolbar" @click="dialogs.showEdit = true">
      <ElIconEdit />
    </el-icon>

    <IframeGantt class="gantt-div" ref="gantt"></IframeGantt>

    <!-- 评估 对话框 -->
    <el-dialog title="阶段编辑" v-model="dialogs.showEdit" :close-on-click-modal="false" width="900px" >
      <el-row style="background-color: whitesmoke;line-height: 30px;height: 30px;padding-top: 3px;margin-top: -10px; border-bottom: 1px solid #e5e5e5">
        <el-col :span="7" style="text-align: left;padding-left: 3px">
          名称
        </el-col>
        <el-col :span="4" style="text-align: center">
          开始日期
        </el-col>
        <el-col :span="4" style="text-align: center">
          结束日期
        </el-col>
        <el-col :span="4" style="text-align: center">
          显示顺序
        </el-col>
        <el-col :span="4" style="text-align: center">
          进度(%)
        </el-col>
        <el-col :span="1" style="text-align: center;">
          <el-icon :size="20" @click="addStage()" >
            <ElIconPlus />
          </el-icon>
        </el-col>
      </el-row>

      <div style="overflow-y:auto ;height: 331px; min-height: 331px;margin-top: 5px;margin-bottom:10px; border: 1px solid #e5e5e5;">
        <el-row v-for="item in stageList" style="margin-bottom: 1px">
          <el-col :span="7" style="text-align: left">
            <el-input v-model="item.name" placeholder="阶段名称" ></el-input>
          </el-col>
          <el-col :span="4" style="text-align: center">
            <el-date-picker v-model="item.start_date" placeholder="开始日期" style="width: 140px"  />
          </el-col>
          <el-col :span="4" style="text-align: center">
            <el-date-picker v-model="item.end_date" placeholder="结束日期" style="width: 140px" />
          </el-col>
          <el-col :span="4" style="text-align: center">
            <el-input-number  style="width:140px" v-model="item.disp_order" step="1" min="1" max="999" placeholder="顺序" clearable></el-input-number>
          </el-col>
          <el-col :span="4" style="text-align: center">
            <el-input-number  style="width:140px" v-model="item.progress_percent" step="1" min="0" max="100" placeholder="进度(%)" clearable></el-input-number>
          </el-col>
          <el-col :span="1" style="text-align: center;">
            <el-icon :size="20" style="margin-top: 5px" @click="removeOneStage(item.id)">
              <ElIconClose />
            </el-icon>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="20" style="text-align: left">
          <el-button type="primary" @click="saveStages">确定</el-button>
          <el-button @click="dialogs.showEdit = false">取消</el-button>
        </el-col>
      </el-row>

    </el-dialog>
  </div>

</template>

<script>

import IframeGantt from './IframeGantt.vue';
import {nanoid} from 'nanoid';

export default {
  name: 'ProjectStage',
  components: { IframeGantt },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      stageList:[],
      dialogs:{
        showEdit: false
      }
    }
  },
  methods: {
    async loadData() {
      this.stageList = await this.$http('prjStageService.getStages', {project_id: this.parentData.id})
      let tasks = {"data": this.stageList, "links": []}

      var config = {}
      config.grid_width = 260;
      // 自定义时间刻度
      config.subscales = [
        { unit: "week", step: 1, date: "%W" }
      ];          //指定第二个时间刻度
      config.columns = [
        { name: "name", label: "阶段名称", tree: true, width: '*' },
        { name: "progress_percentage", label: "进度", width: '50', align: "center"}
      ]
      this.$refs.gantt.refresh(config, tasks);
    },
    async saveStages() {
      await this.$http('prjStageService.saveStages', {project_id: this.parentData.id, stages: this.stageList})
      this.$message.success('保存成功')
      this.dialogs.showEdit = false
      this.loadData();
    },
    addStage(){
      let stage = {
        "id": 'new_' + nanoid(),
        "name": "新阶段" + (this.stageList.length + 1),
        "disp_order": this.stageList.length + 1,
        "progress_percent": 0,
      }
      this.stageList.push(stage)
    },
    removeOneStage(id) {
      console.log("removeOneStage, id=" + id)
      let index = this.stageList.findIndex(item => item.id === id);
      console.log("index=" + index)
      this.stageList.splice(index, 1);
    }
  },
  mounted: function () {
    this.loadData();
  }
}
</script>

<style scoped>

.gantt-container {
  position: relative; /* 确保工具栏的定位是相对于这个容器 */
}

/* 工具栏样式 */
.gantt-toolbar {
  position: absolute;
  top:25px;
  left: 20px;
  z-index: 1000; /* 确保工具栏在甘特图上方 */
}

.gantt-div {
  position: absolute;
  top:0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

</style>